import { LoanLightTopBar } from "@/legacy-components/top-bar";
import { createComponent } from "@lit/react";
import React from "react";

export const LoanLightTopBarWrapper = createComponent({
  react: React,
  tagName: "loanlight-top-bar",
  elementClass: LoanLightTopBar,
});
